/**
 * Authentication feature configuration.
 * Contains all auth-related constants and configuration values.
 */

import { CONFIG } from '@/config.ts';
import { ENV_CONFIG } from '@/envConfig.ts';

/**
 * Authentication URLs used throughout the auth feature
 */
export const AUTH_URLS = {
  /**
   * Login endpoint URL for redirecting unauthenticated users
   */
  LOGIN: `${ENV_CONFIG.apiBaseUrl}${CONFIG.apiPrefix}/login`,
  LOGOUT: `${ENV_CONFIG.apiBaseUrl}${CONFIG.apiPrefix}/logout`,
} as const;

/**
 * Authentication configuration object.
 * This serves as the single source of truth for all auth-related configuration.
 */
export const authConfig = {
  urls: AUTH_URLS,
} as const;
